<template>
  <v-app>
    <Navbar/>
    <v-main class="ma-4">
      <router-view></router-view>
    </v-main>
    <Footer/>
    <notifications group="foo" position="bottom right" classes="custom-notification" width="500" :speed="400"/>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'app',
  components: {
    Navbar
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #F8F8F8;/*#f6f5fa;*/
  font-size: .8rem !important;
}

.v-content{
  padding: 50px 0px 0px 10px !important;
}
</style>
